import RouterLink from 'app/common/components/singlespa/router-link';
import { forNamespace } from 'app/common/lib/util/i18n';
import { Spinner } from 'app/src/components/Spinner';
import { useTeamOnboardingChecklist } from './useTeamOnboardingChecklist';
import React from 'react';
import styles from './TeamOnboardingChecklist.less';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right-large';
import CheckIcon from '@atlaskit/icon/glyph/check';

const format = forNamespace(['team onboarding', 'checklist']);

interface TeamOnboardingChecklistProps {
  orgId: string;
}

export const TeamOnboardingChecklist: React.FC<TeamOnboardingChecklistProps> = ({
  orgId,
}) => {
  const {
    loading,
    checklistItems,
    completedCount,
    dismissChecklistItem,
  } = useTeamOnboardingChecklist(orgId);
  const completedPercentage = Math.ceil(
    (completedCount / checklistItems.length) * 100,
  );

  if (loading) {
    return (
      <div className={styles.container}>
        <Spinner centered />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{format('title')}</h2>
      <p className={styles.subTitle}>{format('subtitle')}</p>
      <div className={styles.progressContainer}>
        <span className={styles.percentage}>{completedPercentage}%</span>
        <span className={styles.progressBar}>
          <span
            className={styles.innerBar}
            style={{ width: `${completedPercentage}%` }}
          />
        </span>
      </div>
      <ul className={styles.checkList}>
        {checklistItems.map(({ key, title, subtitle, href, completed }, i) => (
          <li key={key} data-test-id={`TeamOnboardingChecklist-${key}`}>
            {completed ? (
              <div className={styles.checkListItem}>
                <span className={styles.bullet}>
                  <CheckIcon
                    label=""
                    primaryColor="inherit"
                    secondaryColor="inherit"
                    size="small"
                  />
                </span>
                <span className={styles.checklistContent}>
                  {title} <small>{subtitle}</small>
                </span>
              </div>
            ) : (
              <RouterLink
                href={href}
                className={styles.checkListItem}
                onClick={() => dismissChecklistItem(key)}
              >
                <span className={styles.bullet}>{i + 1}</span>
                <span className={styles.checklistContent}>
                  {title} <small>{subtitle}</small>
                </span>
                <span className={styles.chevron}>
                  <ChevronRightIcon
                    label=""
                    primaryColor="inherit"
                    secondaryColor="inherit"
                    size="medium"
                  />
                </span>
              </RouterLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
